import { z } from 'zod';
import { AdminActionInput, AdminRole } from '../shared.js';
import { CursorQuery } from '../../common/pagination.js';
// ── admin accounts (FR-ADM-02/03) and audit log (FR-ADM-04) ───────────────
export const CreateAdminInput = AdminActionInput.extend({
    email: z.string().email().toLowerCase(),
    password: z.string().min(12),
    // Exactly one: a built-in role, or a custom role authored on the Roles page.
    role: AdminRole.optional(),
    customRoleId: z.string().optional(),
}).refine((v) => (v.role === undefined) !== (v.customRoleId === undefined), {
    message: 'Provide exactly one of role or customRoleId',
});
export const AdminAccountView = z.object({
    id: z.string(),
    email: z.string(),
    /** `'custom'` when the account holds a custom role; `roleName` carries its display name. */
    role: z.union([AdminRole, z.literal('custom')]),
    roleName: z.string(),
    customRoleId: z.string().nullable(),
    mfaEnrolled: z.boolean(),
    suspended: z.boolean(),
    createdAt: z.coerce.date(),
});
export const AuditQuery = CursorQuery.extend({
    actorId: z.string().optional(),
    action: z.string().optional(),
    targetId: z.string().optional(),
});
//# sourceMappingURL=schemas.js.map